import React from 'react';
export const DetailRow = ({ title, value }) => (
  <div className='tw-flex tw-w-full tw-gap-4 tw-py-3 tw-px-4 tw-border-b tw-border-solid tw-border-grey-200 tw-border-x-0 tw-border-t-0 last:tw-border-b-0'>
    <span className='tw-text-lg tw-font-medium tw-text-grey-600 tw-w-[240px] tw-shrink-0'>
      {title}
    </span>
    <span className='tw-text-lg tw-font-medium tw-text-grey-800 tw-break-words'>
      {value || '-'}
    </span>
  </div>
);

const PolicyDetails = ({ policyDetails }) => {
  if (!policyDetails) return null;

  const params =
    policyDetails.item_policy_parameter ||
    policyDetails.order_policy_parameter ||
    {};

  const details = [
    { key: 'Policy Level', value: policyDetails.policy_level },
    ...Object.entries(params).map(([key, value]) => ({
      key,
      value: value || '-',
    })),
    { key: 'Created By', value: policyDetails.created_by },
    {
      key: 'Created At',
      value: policyDetails.created_at
        ? new Date(policyDetails.created_at).toLocaleString()
        : null,
    },
    { key: 'Updated By', value: policyDetails.updated_by },
    {
      key: 'Updated At',
      value: policyDetails.updated_at
        ? new Date(policyDetails.updated_at).toLocaleString()
        : null,
    },
    {
      key: 'Included Complaint Types',
      value: policyDetails.included_complaint_types?.join(', '),
    },
    {
      key: 'Excluded Complaint Types',
      value: policyDetails.excluded_complaint_types?.join(', '),
    },
  ];

  return (
    <div className='tw-border tw-border-solid tw-border-grey-200 tw-rounded-lg tw-bg-white tw-flex tw-flex-col'>
      {details.map((info) => (
        <DetailRow key={info.key} title={info.key} value={info.value} />
      ))}
    </div>
  );
};

export default PolicyDetails;
